export const secondQuotaTime = 30;
export const casheaQuotaTime = 14;

export const numCasheaDues = [
  { _id: 3, name: '3 Cuotas' },
  { _id: 6, name: '6 Cuotas' },
];

export const casheaMaxQuotas = numCasheaDues[numCasheaDues.length - 1]._id;

export const maxCashbackMethods = 3;
// Longitud minima ref PM y Transferencia
export const paymentRefMinLength = 6;

export const maxPercentageBelowDiffAllowed = 0.5; // percent allowed below
export const maxPercentageOverDiffAllowed = 20; // percent allowed over

export const medCert = 15;
